// CONSTANTS are all caps.
const NS = "ReadingTab";
const CLS = "readingTab";
const WG = "." + CLS + "-";
const CLS_MOB_REVEALED = "is-mobileBtnsRevealed";
const CLS_ICON_SHOW = 'is-iconShow';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/readingTab.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import utils from '../utils';

export class ReadingTab {

	constructor($el) {
		// $el is the widget node return by the loadReadingTab function
		this.$el = $el;
		this.$elObj = $($el);
		this.$iconList = this.$elObj.find(WG + 'icons');
		this.$iconItem = this.$elObj.find(WG + 'icon');

		this.isIphone = $('body').hasClass('is-iPhone');
	}

	init() {
		this.initUtilityBar();
		this.setReadingTab();
		this.showReadingTabIcon();
		this.setOpenReadingTabBtn();
		this.setPosition();

		this.$el.classList.add("is-readingTabReady");
	}

	initUtilityBar() {
		const _this = this;
		const $el = $(this.$el);
		const $readingTabToggle = $el.find(`${WG}icon--reading`);
		const $readingTabClose = $el.find(`${WG}icon--close`);
		const $readingTabRevealBtn = $el.find(`${WG}icon--revealBtn`);
		const $shareToggle = $el.find(`${WG}icon--share`);
		const $overlay = $el.find(`${WG}overlay`);

		$shareToggle.on('click', () => {
			$('#socialShareModal').modal('show');
		});

		$readingTabToggle.on('click', function () {
			if ($(this).hasClass('active')) {
				_this.showReadingTab(false);
			} else {
				_this.showReadingTab(true);
			}
		});

		$readingTabClose.on('click', function () {
			_this.showReadingTab(false);
		});

		$readingTabRevealBtn.on('click', function () {
			_this.revealMobileBtns(true);
		});

		$overlay.on('click', () => {
			_this.showReadingTab(false);
		});

		document.addEventListener('keyup', e =>
			e.keyCode === 27 ? _this.showReadingTab(false) : ''
		);
	}

    // CSS Percentage Circle
    // @ref https://jsfiddle.net/ggj55sqo/
    updatePercentageCircle($el, percent) {
        let i = percent * 360 / 100;
        if (i <= 180)
            $el.css('background-image', 'linear-gradient(' + (90 + i) + 'deg, transparent 50%, #fff 50%),linear-gradient(90deg, #fff 50%, transparent 50%)');
        else
            $el.css('background-image', 'linear-gradient(' + (i - 90) + 'deg, transparent 50%, #000 50%),linear-gradient(90deg, #fff 50%, transparent 50%)');
    }

	setReadingTab() {
        let wg = $(this.$el);
        let maxY = document.body.scrollHeight;

		$(document).scroll((e) => {
			let currentY = window.pageYOffset + window.innerHeight;

			// @ref https://stackoverflow.com/questions/1145850/how-to-get-height-of-entire-document-with-javascript
			let percent = Math.floor((currentY / maxY) * 100);
			// Limit percentage to 100 to prevent ridiculous things from happening
			percent = percent > 100 ? 100 : percent;
			wg.find(WG + 'percentText').text(percent + '%');
			wg.find(WG + 'percent').each((index, item) => this.updatePercentageCircle($(item), percent));
        });
		$(document).trigger('scroll');
	}

	/**
	 * On iPhone the icons are collapsed by default because they get it the way.
	* They can't sit right at the bottom like originally intended because bottom 30px on iPhone is reserved for the action bar.
	 */
	revealMobileBtns(doShow) {
		let $wg = $(this.$el);
		if(doShow) 	$wg.addClass(CLS_MOB_REVEALED);
		else		$wg.removeClass(CLS_MOB_REVEALED);

		this.setPosition();
	}

	showReadingTabIcon() {
		let $wg = $(this.$el);

		$(window).on('scroll', () => {
			this.revealMobileBtns(false);
			if(utils.checkBP('tp')) {
				if($(window).scrollTop() > 100) {
					$wg.addClass(CLS_ICON_SHOW);
				} else {
					if(!$wg.hasClass('is-expanded')) $wg.removeClass(CLS_ICON_SHOW);
				}
			}
		});

		$(window).on('resize', () => {
			this.revealMobileBtns(false);
			if(!utils.checkBP('tp')) {
				$wg.removeClass(CLS_ICON_SHOW);
			}
		});
	}

	showReadingTab(doShow) {
		const $el = $(this.$el);
		const $readingTabToggle = $el.find(`${WG}icon--reading`);
		const $content = $el.find(`${WG}content`);
		let readingTabHeight = $content.height();
		let availableHeight = $(window).outerHeight() - $('.siteHeader').outerHeight() - $('.readingTab-icons').outerHeight() - 10;

		if(doShow) {
			this.revealMobileBtns(true);

			if (readingTabHeight > availableHeight) {
				readingTabHeight = availableHeight;
				$content.css({
					'max-height': `${readingTabHeight}px`,
					'overflow-y': 'auto'
				});
			}

			// had to use 100vh (instead of 100%) because iPhone didn't work
			$el.css('top', `calc(100vh - ${readingTabHeight}px)`).addClass('is-expanded');
			$readingTabToggle.addClass('active');
			// $('body').addClass('no-scroll');

		} else {
			$el.css('top', '').removeClass('is-expanded');
			$readingTabToggle.removeClass('active');
			// $('body').removeClass('no-scroll');
			$content.css({
				'max-height': '',
				'overflow-y': ''
			});
			this.revealMobileBtns(false);
		}
	}

	setOpenReadingTabBtn() {
		var _this = this;
		$('.openReadingTab').on('click', (e) => {
			let $readingTabToggle = $('.siteFooter .readingTab').find(`.readingTab-icon--reading`);

			if ($readingTabToggle.hasClass('active')) {
				_this.showReadingTab(false);
			} else {
				_this.showReadingTab(true);
			}
		});
	}

	// set readingTab-icons position (translateX)
	setPosition() {
		if (this.isIphone && this.$iconItem.length > 0) {
			let totalWidth = 0;

			if (!this.$el.classList.contains(CLS_ICON_SHOW)) {
				this.$iconList.css('transform', '');
			} else if (this.$el.classList.contains(CLS_MOB_REVEALED)) {
				this.$iconList.css('transform', `translateY(-95px) translateX(0)`);
			} else {
				let calculateWidth = (icon) => {
					let curStyle = window.getComputedStyle(icon);
					return icon.offsetWidth + parseFloat(curStyle.marginLeft) + parseFloat(curStyle.marginRight);
				};

				this.$iconItem.each((i, icon) => {
					totalWidth += calculateWidth(icon);
				});

				// get 1 icon as substraction to total width so, revealBtn willl appear
				let $icon = this.$iconItem[0];
				let iconWidth = calculateWidth($icon) + 4; // add offset padding

				this.$iconList.css('transform', `translateY(-95px) translateX(${totalWidth - iconWidth}px)`);
			}
		}
	}
}
